import React, { useState, useCallback, useEffect } from 'react';
import {
  Input,
  InputGroup,
  InputLeftAddon,
  IconButton,
  Box,
  Flex,
  Text,
  // InputRightAddon,
  // Menu,
  // MenuButton,
  // MenuList,
  // MenuOptionGroup,
  // MenuItemOption,
} from '@chakra-ui/react';
import { SearchIcon, CloseIcon } from '@chakra-ui/icons';
import { create, insertMultiple, search } from '@orama/orama';
import { likeItemOutside, voteForPaper } from '../../utils/api';
import PaperCardSearch from './PaperCardSearch';

const SearchComponent = ({ userAgenda }) => {
  const [searchQuery, setSearchQuery] = useState('');
  // const [sortOption, setSortOption] = useState('bestMatch');
  const [items, setItems] = useState([]);
  const [database, setDatabase] = useState(null);

  const initializeDatabase = useCallback(async () => {
    const db = await create({
      schema: {
        idx: 'number',
        title: 'string',
        abstract: 'string',
        authors: 'string',
      },
    });

    const conferenceItems = JSON.parse(localStorage.getItem('conferenceItems'));

    if (conferenceItems) {
      const filteredItems = conferenceItems.map(item => ({
        idx: item.idx,
        title: item.title,
        abstract: item.abstract,
        authors: item.authors,
        date: item.date,
        time_start: item.time_start,
        time_end: item.time_end,
        location: item.location,
      }));
      await insertMultiple(db, filteredItems);
    }

    setDatabase(db);
  }, []);

  useEffect(() => {
    initializeDatabase();
  }, [initializeDatabase]);

  const searchItems = useCallback(async () => {
    if (!database) {
      console.error('Database is not initialized');
      return;
    }

    try {
      const results = await search(database, {
        term: searchQuery,
        properties: ['title', 'abstract', 'authors'],
      });
      setItems(results?.hits || []);
    } catch (error) {
      console.error('Failed to search items:', error);
    }
  }, [database, searchQuery]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setItems([]);
  };

  // const handleSortOptionChange = (value) => {
  //   setSortOption(value);
  // };

  useEffect(() => {
    searchItems();
  }, [searchItems]);

  const handleAdd = async (paperId) => {
    await likeItemOutside(paperId);
    console.log(`Added document id ${paperId} to agenda from search`)
    const success = await voteForPaper(paperId);
    console.log(`Item id: ${paperId}, vote success: ${success}`)
  };

  return (
    <>
      <Flex justify="center" align="center" mb={8} mt={35}>
        <InputGroup maxW="600px" w="100%">
          <InputLeftAddon sx={{ backgroundColor: '#cbd5e0', color: '#fff' }}>
            <SearchIcon />
          </InputLeftAddon>
          <Input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{
              border: '1px solid #cbd5e0',
              borderRadius: '0 4px 4px 0',
              boxShadow: 'none',
              _focus: { boxShadow: '0 0 0 2px #fff' }
            }}
          />
          {searchQuery && (
            <IconButton
              icon={<CloseIcon />}
              onClick={clearSearch}
              sx={{
                backgroundColor: 'transparent',
                border: 'none',
                _hover: { backgroundColor: 'transparent' },
                _focus: { boxShadow: 'none' }
              }}
              aria-label="Clear search"
            />
          )}
        </InputGroup>
      </Flex>
      {searchQuery && (
        <Box className="search-results" mt={4}>
          {items.length > 0 ? (
            items.map((item) => (
              <PaperCardSearch
                key={item.document.idx}
                title={item.document.title}
                authors={item.document.authors}
                abstract={item.document.abstract || ''}
                date={item.document.date}
                time_start={item.document.time_start}
                time_end={item.document.time_end}
                location={item.document.location}
                onAdd={() => handleAdd(item.document.idx)}
                hasVoted={userAgenda.includes(item.document.idx)}
              />
            ))
          ) : (
            <Text textAlign="center" mt={4} color="gray.500">
              No results found
            </Text>
          )}
        </Box>
      )}
    </>
  );
};

export default SearchComponent;
